
const Constants = {
    FINIX_API_HOSTNAME: process.env.REACT_APP_FINIX_API_HOSTNAME || 'http://localhost:8080',
};

export default Constants;
